<script setup lang="ts">
import type { Image } from './types'

defineProps<{
  image: Image
}>()
</script>

<template>
  <div class="rounded-lg overflow-hidden w-20 h-20 hover:opacity-80 cursor-pointer">
    <img :src="image.url" alt="Image" class="w-full h-full object-cover bg-gray-100" loading="lazy">
  </div>
</template>
